import { css } from '@emotion/core';

// In px
const MOBILE_CONTAINER_MINIMUM_WIDTH_IN_PX = 375;
const MOBILE_CONTAINER_PADDING_IN_PX = 24;
const MOBILE_CONTENT_MIN_WIDTH_IN_PX =
    MOBILE_CONTAINER_MINIMUM_WIDTH_IN_PX - MOBILE_CONTAINER_PADDING_IN_PX * 2;

// In px
const MOBILE_CONTENT_MAX_WIDTH_IN_PX = 500;

const convertPixelsToRem = (pixels) => `${pixels / 12}rem`;

const MOBILE_CONTENT_MIN_WIDTH = convertPixelsToRem(MOBILE_CONTENT_MIN_WIDTH_IN_PX);
const MOBILE_CONTENT_MAX_WIDTH = convertPixelsToRem(MOBILE_CONTENT_MAX_WIDTH_IN_PX);

const mobileContentWidthCSS = css`
    min-width: ${MOBILE_CONTENT_MIN_WIDTH};
    max-width: ${MOBILE_CONTENT_MAX_WIDTH};
    width: 100%;
`;

export default mobileContentWidthCSS;
